import React from 'react'

import { IconComponent } from '../../../sharedLegacy/components'

import { Tinted } from './Tinted/Tinted'

import './SpeakerGlyph.scss'

type SpeakerGlyphProps = {
  tint?: string
}

const SpeakerGlyph = ({ tint }: SpeakerGlyphProps) => {
  return (
    <Tinted tint={tint} opacity={0.05} className="speaker-glyph">
      <IconComponent name="people" color="FFF" size={[16, 16]} />
    </Tinted>
  )
}

export default SpeakerGlyph
